import React, {useState} from 'react';
import {
    MantineProvider,
    AppShell,
} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import '@mantine/core/styles.css';
import '@mantine/core/styles/Burger.css';

import {BrowserRouter as Router} from 'react-router-dom';

import NavBar from "./components/mainsite/NavBar";
import NavBarLogin from "./components/mainsite/NavBarLogin";
import Header from "./components/mainsite/Header";
import RouterConfig from './routes/router-config';
import UseAuth from "./hooks/UserAuth";
import api from "./services/api";
import API_URL from "./config";


function App() {
    window.API_URL = window.location.origin.toString()
    const [mobileOpened, {toggle: toggleMobile}] = useDisclosure();
    const [desktopOpened, {toggle: toggleDesktop}] = useDisclosure(true);

    const checkIsAuthenticated = () => {
        return api.get(`${API_URL}/users/validate-token/`);
    }


    const userAuthB = () => {
        const token = localStorage.getItem('token');
        if (token) {
            checkIsAuthenticated().then(response => {
                console.log(response.status, response.data)
                if (response.status !== 200) {
                    setAuthUser(false)
                } else {
                    setAuthUser(true)
                }
            })
        }
        return token ? true : false
    }
    const [authUser, setAuthUser] = useState(userAuthB());
    return (
        <MantineProvider>
            <Router>
                <AppShell
                    header={{height: 60}}
                    navbar={{
                        width: 300,
                        breakpoint: 'sm',
                        collapsed: {mobile: !mobileOpened, desktop: !desktopOpened},
                    }}
                    padding="md"
                >
                    <AppShell.Header withBorder={true}>
                        <Header authUser={authUser} toggleMobile={toggleMobile} toggleDesktop={toggleDesktop}/>
                    </AppShell.Header>

                    <AppShell.Navbar p="md">
                        <AppShell.Section>
                            <NavBarLogin authUser={authUser} setAuthUser={setAuthUser}/>
                        </AppShell.Section>
                        <AppShell.Section grow my="md">
                            <NavBar authUser={authUser}/>
                        </AppShell.Section>
                        <AppShell.Section>V.0.1</AppShell.Section>
                    </AppShell.Navbar>
                    <AppShell.Main>
                        <RouterConfig authUser={authUser} setAuthUser={setAuthUser}/>
                    </AppShell.Main>
                </AppShell>
            </Router>
        </MantineProvider>
    );
}

export default App;